<template>
    <modal @close="closeModal">
        <div class="u-margin-bottom">
            {{
                trans(confirmMessage, {
                    entity: confirmEntity
                })
            }}
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray btn-ghost--dns | u-margin-right" @click="closeModal">
                {{ trans(cancelButtonMessage) }}
            </button>
            <button class="btn btn--blue-record btn-ghost--dns" type="submit" @click="confirmModal">
                {{ trans(okButtonMessage) }}
            </button>
        </div>
    </modal>
</template>

<script>
import { Modal } from 'relapp-modal';
export default {
    components: {
        Modal
    },
    props: {
        confirmMessage: {
            type: String,
            default: 'confirm.delete-entity'
        },
        confirmEntity: {
            type: String,
            default: null
        },
        cancelButtonMessage: {
            type: String,
            default: 'action.cancel'
        },
        okButtonMessage: {
            type: String,
            default: 'action.ok'
        }
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Confirm modal.
         */
        confirmModal() {
            this.$emit('confirm', this.confirmEntity);
        }
    }
};
</script>
